import base from './base.repository';
import base2 from './base2.repository';

export default {
    ...base,
    getCompanySlug(){
        this.get(`config/company-slug`);
        return this;
    },
    getVehicleRouteOptions: (clientId) => base2.get(`config/vehicle-route-options/${clientId}`)
}